// matsch: copied from browser-cookie-banner; turned this into a properly exported function

/*
 * @version    1.0.4
 * @date       2015-03-13
 * @stability  3 - Stable
 * @author     Lauri Rooden <lauri@rooden.ee>
 * @license    MIT License
 */

export default function cookieLite(name, value, ttl, path, domain, secure, sameSite) {
	if (arguments.length > 1) {
		return (document.cookie =
			name +
			'=' +
			encodeURIComponent(value) +
			(ttl ? '; expires=' + new Date(+new Date() + ttl * 1000).toUTCString() : '') +
			(path ? '; path=' + path : '') +
			(domain ? '; domain=' + domain : '') +
			(secure ? '; secure' : '') +
			(sameSite ? '; SameSite=' + sameSite : ''));
	}

	return decodeURIComponent((('; ' + document.cookie).split('; ' + name + '=')[1] || '').split(';')[0]);
}
